export enum ServiceType {
    Service = 0,
    DealerNetwork = 1,
    Amenity = 2
}
